import React, { useEffect, useRef, useState } from "react";
import { Button, FormLabel, FormElement, FormInput, CancelButton } from "../../../../../components/StyledElements";
import { RejectionBlock } from "../../../../../components/RejectionBlock";
import swal from "sweetalert2";
import { updateTip, deleteTip } from "../../../../../services/courses";
import { Icon } from "@iconify/react";

export const EditTips = ({ levelSection, courseId, onUpdatetip = () => { }, style = {} }) => {

  const containerRef = useRef(null);

  const [currentTipIndex, setCurrentTipIndex] = useState(0);
  const [currentTip, setCurrentTip] = useState();
  const [updatedTip, setUpdatedTip] = useState();
  const [savingTip, setSavingTip] = useState(false);

  console.log("!!! LEVEL SECTION: ", levelSection);

  const checkUpdatedSpeechIntervalRef = useRef(null);
  //
  //  
  useEffect(() => {
    console.log("CONTAINER REF: ", containerRef.current);
    const r = window.addEventListener("resize", () => {
      if (containerRef.current) {
        const newContainerWidth = containerRef.current.getBoundingClientRect().width;
        const offset = (currentTipIndex + 1) * (newContainerWidth + 10);
        containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
      }
    });

    return () => {
      window.removeEventListener("resize", r);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (checkUpdatedSpeechIntervalRef.current) {
      clearInterval(checkUpdatedSpeechIntervalRef.current);
    }

    if (levelSection?.tips) {
      const currentTip = levelSection.tips[currentTipIndex];
      setCurrentTip(currentTip);
      setUpdatedTip(currentTip);

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTipIndex, levelSection?.tips]);

  useEffect(() => {
    // Get the current hash from the URL and set the current block accordingly
    if (!levelSection?.tips || levelSection.tips.length === 0) {
      return;
    }

    const hash = window.location.hash;
    const parts = hash.split("&");
    console.log("!!! pARTS: ", parts);
    if (parts.length > 0 && parts[0] === "#tip") {
      if (parts && parts.length > 1) {
        if (!parts[1].match(/^\d+$/)) {
          const blockIndex = levelSection.tips.findIndex((b) => b.public_id === parts[1]);
          if (blockIndex !== -1) {
            setCurrentTipIndex(blockIndex);
            const offset = blockIndex * (containerRef.current.getBoundingClientRect().width + 10);
            containerRef.current.scrollTo({ left: offset });
            return;
          } else {
            console.log("!!! BLOCK NOT FOUND: ", parts[1]);
          }
        }
        const blockIndex = parseInt(parts[1]);
        console.log("!!! BLOCK INDEX: ", blockIndex);
        if (!isNaN(blockIndex) && blockIndex > 0 && blockIndex <= levelSection?.tips?.length) {
          setCurrentTipIndex(blockIndex - 1);
          const offset = (blockIndex - 1) * (containerRef.current.getBoundingClientRect().width + 10);
          containerRef.current.scrollTo({ left: offset });
        }
      } else {
        console.log("!!! CHANGING TO tip 1")
        window.history.replaceState(null, null, `#tip&1`);
        setCurrentTipIndex(0);
        containerRef.current.scrollTo({ left: 0 });
      }
    }
  }, [levelSection?.tips]);

  const hasChanged = () => {
    if (!currentTip || !updatedTip) {
      return false;
    }
    return currentTip.tip !== updatedTip.tip;
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", ...style }}>
        <div style={{ position: "absolute", top: 20, right: 20, display: "flex", zIndex: 200, flexDirection: "row", gap: "10px" }}>
          <CancelButton onClick={() => {
            swal.fire({
              title: "Are you sure?",
              text: "Any unsaved changes will be lost.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, cancel",
              cancelButtonText: "No, keep editing",
            }).then((result) => {
              console.log("!!! RESULT: ", result);
              if (result?.value) {
                setUpdatedTip(currentTip);
              }
            });
          }}>Cancel</CancelButton>
          <Button disabled={!hasChanged() || savingTip} style={{ marginLeft: "auto" }}
            onClick={async () => {
              if (!hasChanged()) {
                return;
              }


              // open a sweetalert2 modal until the save is complete
              swal.fire({
                title: "Saving...",
                text: "Please wait while the tip block is being saved.",
                allowOutsideClick: false,
                didOpen: () => {
                  swal.showLoading();
                },
              });

              setSavingTip(true);
              const results = await updateTip(updatedTip);
              setSavingTip(false);

              if (results.success) {
                //const newUpdatedTip = results.tip;
                setCurrentTip(updatedTip);
                onUpdatetip({ ...results.tip });

                swal.fire({
                  title: "Success",
                  text: "tip block saved successfully.",
                  icon: "success",
                });
              } else {
                swal.fire({
                  title: "Error",
                  text: results.error || "An error occurred while saving the tip block.",
                  icon: "error",
                });
              }
            }}
          >
            {savingTip ? "Saving Tip..." : "Save Tip"}
          </Button>
        </div>
        <div style={{ display: "flex", flexDirection: "row", justifytip: "space-between", alignItems: "center", marginBottom: "10px" }}>
          <FormLabel label={`Tip ${currentTipIndex + 1} of ${levelSection?.tips?.length}`} />
          <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
            <Icon icon="mdi:delete" height={20} width={20} style={{ cursor: "pointer", color: "var(--error-color)" }} onClick={() => {
              swal.fire({
                title: "Are you sure?",
                text: "This will delete the current block. This action cannot be undone.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it",
                cancelButtonText: "No, keep it",
              }).then(async (result) => {
                if (result?.value) {
                  const results = await deleteTip(currentTip.public_id);
                  if (results.success) {
                    swal.fire({
                      title: "Deleted!",
                      text: "The tip block has been deleted.",
                      icon: "success",
                    });
                    // Remove the block from the levelSection.quiz.blocks array
                    onUpdatetip({ ...currentTip }, true);
                  } else {
                    swal.fire({
                      title: "Error",
                      text: results.error || "An error occurred while deleting the block.",
                      icon: "error",
                    });
                  }
                }
              });
            }} />
          </div>
        </div>
        <RejectionBlock tipPublicId={currentTip?.public_id} />

        <FormElement>
          <FormInput value={updatedTip?.public_id ?? ""} style={{ backgroundColor: "white" }} disabled />
        </FormElement>



        <div ref={containerRef} id="tip-blocks-container" style={{ width: "100%", marginBottom: "10px", overflow: "hidden" }}>
          <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px", flowWrap: "nowrap" }}>
            {/*Each tip block will be displayed as it's own page, and the wrapper will scroll horizontally to show the next tip block*/}
            {levelSection?.tips?.map((block, index) => {
              const isCurrent = index === currentTipIndex;
              const tipData = isCurrent ? updatedTip : block;

              return (
                <FormElement key={index} style={{ flex: "0 0 100%", marginRight: "10px" }}>
                  <FormInput
                    as="textarea"
                    value={tipData?.tip ?? ""}
                    readOnly={!isCurrent}
                    style={{ width: "100%", height: "200px", resize: "vertical" }}
                    onChange={isCurrent ? (e) => {
                      const newTip = { ...updatedTip };
                      newTip.tip = e.target.value;
                      setUpdatedTip(newTip);
                    } : null}
                  />
                </FormElement>
              );
            })}
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
          {currentTipIndex > 0 ? (
            <Button style={{ justifySelf: "flex-start" }} onClick={() => {
              const width = containerRef.current.getBoundingClientRect().width;
              const offset = (currentTipIndex - 1) * (width + 10);
              setCurrentTipIndex(currentTipIndex - 1);
              containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
              window.history.replaceState(null, null, `#tip&${currentTipIndex - 1}`);
            }}>Previous</Button>
          ) : null}
          {
            currentTipIndex < levelSection?.tips?.length - 1 ? (
              <Button style={{ justifySelf: "flex-end", marginLeft: "auto" }} onClick={() => {
                const width = containerRef.current.getBoundingClientRect().width;
                const offset = (currentTipIndex + 1) * (width + 10);
                setCurrentTipIndex(currentTipIndex + 1);
                containerRef.current.scrollTo({ left: offset, behavior: "smooth" });
                // Update the current url hash to reflect the current tip block
                window.history.replaceState(null, null, `#tip&${currentTipIndex + 2}`);
              }}>Next</Button>) : null}
        </div>
      </div>
    </>
  )
}

export default EditTips;
